import { FloatingFormItem } from '@/components/_common';
import { useWomBasketCreate } from '@/core/domain/wom/womBasket/womBasket.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Alert, Form, Input, message, Modal } from 'antd';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useEffect } from 'react';

interface Props {
  opened: boolean;
  onClose: VoidFunction;
  onCreated: VoidFunction;
}

interface FormValues {
  basketName: string;
  additionalInformation: string;
}

export default function WomBasketCreateModal(props: Props) {
  const [form] = Form.useForm<FormValues>();

  const ruleRequired = useDefaultEmptyFieldError();

  const basketCreate = useWomBasketCreate();

  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const handleClose = () => {
    form.resetFields();
    props.onClose();
  };

  useEffect(() => {
    if (workorder && complement && props.opened) {
      form.setFieldValue(
        'basketName',
        `${complement.complementIdentifier} • ${workorder.customer?.name} ${
          workorder.vehicle
            ? `• ${workorder.vehicle.licensePlate}/${workorder.vehicle.model}`
            : ''
        }`.trim(),
      );
    }
  }, [workorder, complement, props.opened]);

  const handleSubmit = async () => {
    try {
      if (!workorder?.customer) {
        return message.warn('Orçamento não possui um cliente');
      }

      if (workorder && workorder.customer && complement) {
        const values = await form.validateFields();

        await basketCreate.mutateAsync({
          basket: {
            orderNumber: complement.complementIdentifier,
            basketName: values.basketName.slice(0, 100),
            additionalInformation: values?.additionalInformation,
          },
          companyId: workorder?.company.id,
          customerId: workorder.customer?.id,
          vehicleId: workorder.vehicle?.id,
          workOrderComplementId: complement.id,
        });

        form.resetFields();
        props.onCreated();
      }
    } catch {}
  };

  return (
    <Modal
      open={props.opened}
      onCancel={handleClose}
      title="Criação de cesta Bosch WOM"
      okText="Criar cesta"
      onOk={handleSubmit}
      confirmLoading={basketCreate.isLoading}
      maskClosable={false}
    >
      <Alert
        style={{ marginBottom: 24 }}
        type="warning"
        description="Será criado uma cesta de compra de produtos do catalogo de peças da Bosch WOM"
      />

      <Form form={form}>
        <FloatingFormItem
          name="basketName"
          label="Nome da cesta"
          rules={[ruleRequired]}
        >
          <Input disabled />
        </FloatingFormItem>

        <FloatingFormItem
          name="additionalInformation"
          label="Informações adicionais"
        >
          <Input />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
}
